import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Fishing Boat Transport',
    desc: 'Safe and secure nationwide boat transport for center consoles, sport-fishing, and offshore boats.',
    img: 'https://cdn.magicpatterns.com/uploads/3jy37SiJzzmjo21hP3kMya/Fishing_Boat.png'
  }, {
    title: 'Yacht Transport',
    desc: 'Specialized handling and premium yacht shipping logistics for luxury vessels.',
    img: 'https://cdn.magicpatterns.com/uploads/gt2NwZvJZVXWXMdTRCiYGe/Yacht_Transport.png'
  }, {
    title: 'Houseboat Transport',
    desc: 'Heavy-duty hauling and oversized permitting for safe houseboat transport across the country.',
    img: 'https://cdn.magicpatterns.com/uploads/fJZZ9bhBDL7KQvXwWmoMku/House_Boat.png'
  }, {
    title: 'Pontoon Transport',
    desc: 'Dedicated trailers designed specifically for the safe transport of pontoon boats.',
    img: 'https://cdn.magicpatterns.com/uploads/orKKYupZZq78hKwos5zCMJ/Pontoon_Boat.png'
  }, {
    title: 'Bow Rider Transport',
    desc: 'Fast, affordable boat transport for bow rider boats and weekend runabouts of all sizes.',
    img: 'https://cdn.magicpatterns.com/uploads/umB5FtUJHGDaEV9QNzDtWx/Bowrider_Boats.png'
  }, {
    title: 'Cabin Cruiser Transport',
    desc: 'Secure, professional boat transport for cabin cruisers and sport-fishing vessels of every size.',
    img: 'https://cdn.magicpatterns.com/uploads/dp2e1N7Kok8UuDh2YkTCzM/Cabin_Cruiser.png'
  }];
  return <section className="py-20 bg-brand-navy text-white" data-id="element-288">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-290">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-291">
            Comprehensive Boat Transport Services
          </h2>
          <p className="text-lg text-slate-300" data-id="element-292">
            From jet skis to luxury yachts, our boat movers have the equipment
            and expertise to handle any marine transport requirement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-293">
          {services.map((service, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="group relative overflow-hidden rounded-2xl bg-brand-navy-light border border-white/10" data-id="element-294">
              <div className="aspect-w-16 aspect-h-9 w-full h-64 overflow-hidden" data-id="element-295">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-296" />
                <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-brand-navy via-brand-navy/70 to-transparent" data-id="element-297"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-298">
                <h3 className="text-lg font-bold mb-1" data-id="element-299">{service.title}</h3>
                <p className="text-sm text-slate-300 leading-snug" data-id="element-300">
                  {service.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}